import { ActionType } from './types'

import { Country } from 'types'

import createReducer from '../createReducer'
import { Action, Nullable } from '../model'

export interface CountriesReducer {
  countries: Nullable<Country[]>
}

const defaultState: CountriesReducer = {
  countries: null,
}

export const countriesReducer = createReducer<CountriesReducer>(defaultState, {
  [ActionType.SET_COUNTRIES]: (state: Nullable<CountriesReducer>, action: Action<Nullable<Country[]>>) => ({
    ...state,
    countries: action.payload,
  }),
})
